import RestfulService from "../common/RestfulService";

const templateQuestionService = new RestfulService("/issb/template-question");

/**
 * TODO update questions made from a template question to use the latest version of the template question
 * @param {*} param0
 * @returns
 */
templateQuestionService.updateExistingRounds = ({ templateQuestionId }) => {
  console.log(templateQuestionService);
  let url = templateQuestionService.path + "/update-existing-rounds";
  url += "?templateQuestionId=" + templateQuestionId;
  return templateQuestionService.axios.post(url).then(({ data }) => data);
};

export default templateQuestionService;
